<script setup>
const show = ref(false);
const ctx = ref({});

// this will hold the promise's 'resolve' function
const giveBack = ref();

// show the prompt
async function prompt(context) {
  show.value = true;
  // set values to display
  ctx.value = context;
  return new Promise((resolve) => {
    // provide a way for interface elements to resolve
    // the promise and return a meaningful value
    giveBack.value = function (val) {
      resolve(val);
      show.value = false;
    };
  });
}

defineExpose({ prompt });
</script>

<template>
  <div>
    <v-dialog v-model="show" width="500">
      <v-container class="bg-white">
        <v-row>
          <v-col>
            {{ ctx.question }}
          </v-col>
        </v-row>
        <v-row v-if="!!ctx.details">
          <v-col>
            <p class="text-medium-emphasis">
              {{ ctx.details }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn class="mr-3" @click="giveBack(false)"> No </v-btn>
            <v-btn @click="giveBack(true)"> Si </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </div>
</template>
